import React from 'react';

import { Box } from '@atlaskit/primitives';

import {
  SuggestionCardCode,
  SuggestionCardLineNumber,
  SuggestionCardLineNumbers,
  SuggestionCardLine,
} from './styles';
import { Line } from './types';

type Props = {
  line: Line;
  gutterWidth: number;
  index: number;
};

export const CodeLine = React.memo(({ line, gutterWidth, index }: Props) => {
  const { lineNumber, content, type } = line;

  return (
    <Box xcss={SuggestionCardLine({ type })} key={`chunk-line-${index}`}>
      <Box xcss={SuggestionCardLineNumbers({ gutterWidth, type })}>
        <Box xcss={SuggestionCardLineNumber}>{lineNumber}</Box>
      </Box>
      <Box xcss={SuggestionCardCode({ type })}>
        <span
          className="code-component"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Box>
    </Box>
  );
});
